export const selectMilestonePresetationSettings = ({ milestoneDefinitions }) =>
  milestoneDefinitions?.milestonePresentationSettings;
